import { normalizeCrematoriumPhone } from "goi_common/src/design-system";

import crematoriums from "@/constants/hwajang_detail.json";

/** 번호 정규화와 고이 대표번호는 goi_common 공용본을 쓴다. 기존 import 경로 유지용 re-export. */
export { GOI_CALL_NUMBER, normalizeCrematoriumPhone } from "goi_common/src/design-system";

/**
 * 라우트 파라미터로 화장장 번호를 찾는다.
 *
 * 화장장 화면마다 [id] 에 들어가는 값이 다르다.
 * - `/crematorium/[id]` : companyname (예: 제천시 영원한쉼터)
 * - `/crematorium-recommendation/[id]` : 숫자 id (예: 144)
 *
 * 둘은 형태가 겹치지 않아 한 함수에서 같이 본다.
 * 화장장 데이터를 들고 있지 않은 전역 컴포넌트(Header 등)에서 쓴다.
 * 페이지 안에서는 이미 crematorium 객체가 있으므로 normalizeCrematoriumPhone 만 쓰면 된다.
 *
 * @param id - router.query.id (string | string[] | undefined)
 * @returns 정규화된 번호, 못 찾거나 값이 없으면 null
 */
export const getCrematoriumPhoneByRouteId = (id: string | string[] | undefined): string | null => {
  if (typeof id !== "string") return null;

  const found = crematoriums.find(
    (crematorium) => crematorium.companyname === id || String(crematorium.id) === id,
  );
  return normalizeCrematoriumPhone(found?.telephone);
};
